
import * as types from './types';

export const setLoading = (isLoading = true, part = 'profile') => ({
  type: types.SCHOOL_CANDIDATE_CANDIDATE_SET_REFERENCES_LOADING,
  isLoading,
  part
});

export const setSchoolCandidateReferencesSummaries = schoolCandidateReferencesSummaries => ({
  type: types.SCHOOL_CANDIDATE_SET_CANDIDATE_REFERENCES_SUMMARIES,
  schoolCandidateReferencesSummaries
});

export const getSchoolCandidateReferencesSummaries = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_GET_CANDIDATE_REFERENCES_SUMMARIES,
  schoolId,
  candidateId
});

export const addSchoolCandidateReferenceToCache = (candidateReferenceId, candidateReference) => ({
  type: types.SCHOOL_CANDIDATE_ADD_CANDIDATE_REFERENCE_TO_CACHE,
  candidateReferenceId,
  candidateReference
});

export const getSchoolCandidateReferenceFromCache = (candidateReferenceId) => ({
  type: types.SCHOOL_CANDIDATE_GET_CANDIDATE_REFERENCE_FROM_CACHE,
  candidateReferenceId
});

export const getSelectedSchoolCandidateReference = (schoolId, candidateId, candidateReferenceId) => ({
  type: types.SCHOOL_CANDIDATE_GET_SELECTED_CANDIDATE_REFERENCE,
  schoolId, 
  candidateId,
  candidateReferenceId
});

export const setSelectedSchoolCandidateReference = candidateReference => ({
  type: types.SCHOOL_CANDIDATE_SET_SELECTED_CANDIDATE_REFERENCE,
  candidateReference
});

export const resetSchoolCandidateReferences = () => ({
  type: types.SCHOOL_CANDIDATE_RESET_CANDIDATE_REFERENCES
});

export const getSchoolCandidateCommentList = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_GET_COMMENT_LIST,
  schoolId,
  candidateId
});

export const setSchoolCandidateCommentList = (comments) => ({
  type: types.SCHOOL_CANDIDATE_SET_COMMENT_LIST,
  comments
});

export const setSchoolCandidateCommentListLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_COMMENT_LIST_LOADING,
  isLoading
});

export const createSchoolCandidateComment = (schoolId, candidateId, parentCommentId, text, important) => ({
  type: types.SCHOOL_CANDIDATE_CREATE_COMMENT,
  schoolId, 
  candidateId, 
  parentCommentId,
  text,
  important
});

export const updateSchoolCandidateComment = (schoolId, candidateId, commentId, text, important) => ({
  type: types.SCHOOL_CANDIDATE_UPDATE_COMMENT,
  schoolId, 
  candidateId, 
  commentId,
  text,
  important
});

export const deleteSchoolCandidateComment = (schoolId, candidateId, commentId) => ({
  type: types.SCHOOL_CANDIDATE_DELETE_COMMENT,
  schoolId, 
  candidateId,
  commentId
});

export const setSchoolCandidateCommentUpdating = (isLoading = false) => ({
  type: types.SCHOOL_CANDIDATE_SET_COMMENT_UPDATING,
  isLoading
});

export const setSchoolCandidateCommentCreating = (isLoading = false) => ({
  type: types.SCHOOL_CANDIDATE_SET_COMMENT_CREATING,
  isLoading
});

export const setSchoolCandidateCommentDeleting = (isLoading = false) => ({
  type: types.SCHOOL_CANDIDATE_SET_COMMENT_DELETING,
  isLoading
});

export const setSchoolCandidateProfileHealth = (health) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_HEALTH,
  health
});

export const setSchoolCandidateProfileHousingPreferences = (housingPreferences) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES,
  housingPreferences
});

export const setSchoolCandidateProfileLanguages = (languages) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_LANGUAGES,
  languages
});

export const setSchoolCandidateProfilePersonal = (personal) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_PERSONAL,
  personal
});

export const setSchoolCandidateProfileSecondarySchools = (secondarySchools) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS,
  secondarySchools
});

export const setSchoolCandidateProfileSportActivities = (sportActivities) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES,
  sportActivities
});

export const setSchoolCandidateProfileBiographicalInformation = (biographicalInformation) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION,
  biographicalInformation
});

export const setSchoolCandidateProfileTeachingCredentials = (teachingCredentials) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS,
  teachingCredentials
});

export const setSchoolCandidateProfileTeachingExperience = (teachingExperience) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE,
  teachingExperience
});

export const setSchoolCandidateProfileUniversitiesColleges = (universitiesColleges) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES,
  universitiesColleges
});

export const setSchoolCandidateProfileContactInformation = (contactInformation) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION,
  contactInformation
});

export const setSchoolCandidateProfileDocuments = (documents) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_DOCUMENTS,
  documents
});




export const setSchoolCandidateProfileHealthLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_HEALTH_LOADING,
  isLoading
});

export const setSchoolCandidateProfileHousingPreferencesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES_LOADING,
  isLoading
});

export const setSchoolCandidateProfileLanguagesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_LANGUAGES_LOADING,
  isLoading
});

export const setSchoolCandidateProfilePersonalLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_PERSONAL_LOADING,
  isLoading
});

export const setSchoolCandidateProfileSecondarySchoolsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS_LOADING,
  isLoading
});

export const setSchoolCandidateProfileSportActivitiesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES_LOADING,
  isLoading
});

export const setSchoolCandidateProfileBiographicalInformationLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION_LOADING,
  isLoading
});

export const setSchoolCandidateProfileTeachingCredentialsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS_LOADING,
  isLoading
});

export const setSchoolCandidateProfileTeachingExperienceLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE_LOADING,
  isLoading
});

export const setSchoolCandidateProfileUniversitiesCollegesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES_LOADING,
  isLoading
});

export const setSchoolCandidateProfileContactInformationLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION_LOADING,
  isLoading
});

export const setSchoolCandidateProfileDocumentsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_SET_DOCUMENTS_LOADING,
  isLoading
});

export const getSchoolCandidateProfileHealth = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_HEALTH,
  schoolId, candidateId
});

export const getSchoolCandidateProfileHousingPreferences = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_HOUSING_PREFERENCES,
  schoolId, candidateId
});

export const getSchoolCandidateProfileLanguages = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_LANGUAGES,
  schoolId, candidateId
});

export const getSchoolCandidateProfilePersonal = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_PERSONAL,
  schoolId, candidateId
});

export const getSchoolCandidateProfileSecondarySchools = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_SECONDARY_SCHOOLS,
  schoolId, candidateId
});

export const getSchoolCandidateProfileDocuments = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_DOCUMENTS,
  schoolId, candidateId
});

export const getSchoolCandidateProfileSportActivities = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_SPORT_ACTIVITIES,
  schoolId, candidateId
});

export const getSchoolCandidateProfileBiographicalInformation = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_BIOGRAPHICAL_INFORMATION,
  schoolId, candidateId
});

export const getSchoolCandidateProfileTeachingCredentials = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_TEACHING_CREDENTIALS,
  schoolId, candidateId
});

export const getSchoolCandidateProfileTeachingExperience = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_TEACHING_EXPERIENCE,
  schoolId, candidateId
});

export const getSchoolCandidateProfileUniversitiesColleges = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_UNIVERSITIES_COLLEGES,
  schoolId, candidateId
});

export const getSchoolCandidateProfileContactInformation = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PROFILE_GET_CONTACT_INFORMATION,
  schoolId, candidateId
});

export const getSchoolCandidateApplicationHistory = (schoolId, candidateId, queryParams) => ({
  type: types.SCHOOL_CANDIDATE_GET_APPLICATION_HISTORY,
  schoolId,
  candidateId,
  queryParams
});

export const setSchoolCandidateApplicationHistory = (applications) => ({
  type: types.SCHOOL_CANDIDATE_SET_APPLICATION_HISTORY,
  applications
});

export const setSchoolCandidateApplicationHistoryLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_APPLICATION_HISTORY_LOADING,
  isLoading
});

export const setSchoolCandidateAddingToFavorites = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_ADDING_TO_FAVORITES,
  isLoading
});

export const addSchoolCandidateToFavorites = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_ADD_TO_FAVORITES,
  schoolId,
  candidateId
});

export const setSchoolCandidateRemovingFromFavorites = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_REMOVING_FROM_FAVORITES,
  isLoading
});

export const removeSchoolCandidateFromFavorites = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_REMOVE_FROM_FAVORITES,
  schoolId,
  candidateId
});

export const setSchoolCandidateBlocking = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_BLOCKING,
  isLoading
});

export const blockSchoolCandidate = (schoolId, blockCandidateRequest) => ({
  type: types.SCHOOL_CANDIDATE_BLOCK,
  schoolId,
  blockCandidateRequest
});

export const setSchoolCandidateUnblocking = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_SET_UNBLOCKING,
  isLoading
});

export const unblockSchoolCandidate = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_UNBLOCK,
  schoolId,
  candidateId
});




// WEBPACK FOOTER //
// ./src/actions/school-candidate/index.js